module.exports = __webpack_public_path__ + "d753fd7d5e34325a0f43d1c4c4eeb80a.png";